import { Link } from "react-router-dom";
import { MoreHorizontal } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

/** Which actions the current Super Admin may take on a row (mirrors the server rules). */
export function allowedActions(row, actor, actorIsOwner) {
  if (row.kind === "invitation") {
    if (row.role === "super_admin" && !actorIsOwner) return [];
    return ["resend", "cancel"];
  }
  if (row.is_owner || row.id === actor?.id || row.status === "revoked") return [];
  if (row.role === "super_admin" && !actorIsOwner) return [];
  return ["role", row.status === "suspended" ? "reactivate" : "suspend", "revoke"];
}

const LABELS = { role: "Change role", suspend: "Suspend", reactivate: "Reactivate", revoke: "Revoke access", resend: "Resend invitation", cancel: "Cancel invitation" };
const DANGER = new Set(["suspend", "revoke", "cancel"]);

export function TeamRowActions({ row, actions, onAction }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button type="button" aria-label={`Actions for ${row.email}`} className="pf-btn-glass w-8 h-8 rounded-full inline-flex items-center justify-center" data-testid={`team-row-actions-${row.id}`}>
          <MoreHorizontal className="w-4 h-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {row.kind === "member" && (
          <DropdownMenuItem asChild><Link to={`/admin/team/${row.id}`} data-testid={`team-action-view-${row.id}`}>View details</Link></DropdownMenuItem>
        )}
        {row.kind === "member" && actions.length > 0 && <DropdownMenuSeparator />}
        {actions.map((a) => (
          <DropdownMenuItem key={a} onSelect={() => onAction(a, row)} className={DANGER.has(a) ? "text-red-700 focus:text-red-700" : ""}
            data-testid={`team-action-${a}-${row.id}`}>{LABELS[a]}</DropdownMenuItem>
        ))}
        {row.kind === "invitation" && actions.length === 0 && (
          <DropdownMenuItem disabled>Managed by the main owner</DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
